import PageTitleComponent from "../../components/PageTitle";
import DeliveryLocations from "../../components/Shipping/DeliveryLocations";

export default function DeliveryLocationsScreen(){
return <div>
    <PageTitleComponent title="Delivery Locations" />
    <DeliveryLocations/>
</div>
}